// components/common/Tabs.js
import React from 'react';

const Tabs = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div className="flex space-x-4 border-b border-gray-300 dark:border-gray-700 mb-4">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabClick(tab)}
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === tab
              ? 'border-blue-500 text-blue-600 dark:text-white border-b-2'
              : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-300'
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
